module.exports = __webpack_public_path__ + "svg/new-bankaxept-small.1738147555ba0c491c3bc699ab0031a6.svg";